<template>
  <b-modal id="updateDevicePeripheralDeviceModal" size="xl" hide-footer @hidden="resetData">
    <b-row slot="modal-header">
      <b-col>
        <h6>{{ $t('modals.excmdeviceperipheraldevice.updateDevicePeripheralDeviceHeader') }}</h6>
      </b-col>
    </b-row>
    <b-row v-if="deviceperipheraldevice">
      <b-col>
        <EXCMDevicePeripheralDeviceUpdate :deviceperipheraldeviceId="deviceperipheraldevice['@id']"></EXCMDevicePeripheralDeviceUpdate>
      </b-col>
    </b-row>
  </b-modal>
</template>

<script>
import EXCMDevicePeripheralDeviceUpdate from '../Update.vue'
import getId from '@/utils/getIdFromLink'
export default {
  name: 'UpdateDevicePeripheralDeviceModal',
  components: {
    EXCMDevicePeripheralDeviceUpdate
  },
  computed: {
    show () {
      return this.$store.state.modals.excmdeviceperipheraldevice.update.show
    },
    devicePivot () {
      return this.$store.state.modals.excmdeviceperipheraldevice.update.devicePivot
    },
    close () {
      return this.$store.state.modals.excmdeviceperipheraldevice.update.close
    }
  },
  watch: {
    'show': function (val) {
      this.openModal()
    },
    'devicePivot': function (val) {
      this.openModal()
    },
    'close': function (val) {
      this.closeModal()
    }
  },
  data () {
    return {
      deviceperipheraldevice: null
    }
  },
  methods: {
    openModal () {
      if (this.show === 1 && this.devicePivot) {
        this.deviceperipheraldevice = Object.assign({}, this.devicePivot)
        this.$store.state.modals.excmdeviceperipheraldevice.update.show = 0
        this.$store.state.modals.excmdeviceperipheraldevice.update.devicePivot = null
        this.$bvModal.show('updateDevicePeripheralDeviceModal')
      }
    },
    closeModal () {
      if (this.close === 1) {
        this.$store.state.modals.excmdeviceperipheraldevice.update.close = 0
        this.$bvModal.hide('updateDevicePeripheralDeviceModal')
      }
    },
    getIdLink (link) {
      return getId(link)
    },
    resetData () {
      // console.log()
    }
  }
}
</script>
